// extracted by mini-css-extract-plugin
module.exports = {"ciamWrapper":"ciam_ciamWrapper__y_UUO","disableBorder":"ciam_disableBorder__OnXG_"};